<script setup>
import { BDropdownItem, BNavItemDropdown, useColorMode } from 'bootstrap-vue-next';
import { computed, onMounted, watch } from 'vue';

import { store } from '~/store';

import FaAdjust from '~icons/fa/adjust';
import FaMoonO from '~icons/fa/moon-o';
import FaSunO from '~icons/fa/sun-o';

const colorMode = useColorMode({
  persist: true,
});

const themeMap = {
  dark: FaMoonO,
  light: FaSunO,
  auto: FaAdjust,
};

const themeOptions = Object.keys(themeMap);
const currentThemeIcon = computed(() => themeMap[colorMode.value]);

const setTheme = (newValue) => {
  colorMode.value = newValue;
};

onMounted(() => {
  watch(
    colorMode,
    (newValue) => {
      if (newValue === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }

      store.setTheme(newValue);
    },
    { immediate: true },
  );
});
</script>

<template>
  <BNavItemDropdown
    toggle-class="px-0 mx-2 d-flex align-items-center"
    class="d-flex align-items-center"
  >
    <template #button-content>
      <component
        :is="currentThemeIcon"
        height="1.1rem"
        :aria-label="`Toggle theme (${colorMode})`"
        class="d-inline-block"
      />
    </template>
    <BDropdownItem
      v-for="theme in themeOptions"
      :key="theme"
      :active="colorMode === theme"
      @click="setTheme(theme)"
    >
      <component :is="themeMap[theme]" /> {{ theme }}
    </BDropdownItem>
  </BNavItemDropdown>
</template>
